export const publications = [
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Kohnoor Bano, Dhrubajyoti Talukdar, Bappaditya Gole
            </>
        ),
        title: "Thermochemical valorization of essential oil industry waste into fuels and carbon-rich products under varying heating rates",
        journal: "Energy Conversion and Management",
        year: 2026,
        impactFactor: 10.0,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Dhrubajyoti Talukdar, Bappaditya Gole
            </>
        ),
        title: "Pyrolytic evaluation of essential oil industry waste: Effect of pyrolysis temperature on bio-oil composition",
        journal: "Journal of Environmental Management",
        year: 2025,
        impactFactor: 8.6,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Karan Gupta, <strong>Priyanka Katiyar</strong>,  Ajay Kale, Kavita Khatana, Sanjeev Yadav
            </>
        ),
        title: "Innovative Biochar‐Infused Membranes for Efficient Pollutant Removal From Textile and Pharmaceutical Wastewater",
        journal: "BWater Environment Research",
        year: 2025,
        impactFactor: 2.0,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Aayush Raizada, Amresh Shukla, Sanjeev Yadav, Sourodipto Modak, <strong>Priyanka Katiyar</strong>
            </>
        ),
        title: "Food Waste Ash Supported Nickel Catalyst to Steam Gasification of Food Waste for Enhanced Tar Reduction and Hydrogen Production",
        journal: "BioEnergy Research",
        year: 2025,
        impactFactor: 3.1,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav
            </>
        ),
        title: "Distribution and characterization of products obtained from pyrolysis of cooked food waste - Impact of heating rate",
        journal: "Journal of Analytical and Applied Pyrolysis",
        year: 2024,
        impactFactor: 5.8,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav
            </>
        ),
        title: "A Comprehensive characterisation of food waste for its sustainable and holistic management using thermochemical processes",
        journal: "Indian Chemical Engineer",
        year: 2024,
        impactFactor: 1.2,
        tier: "Q3",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Geetesh Kumar, Sanjeev Yadav
            </>
        ),
        title: "Effective Removal of Methylene Blue Dye Using Low-Cost Essential Oil Industry Waste: Novel Hybrid Design Approach, Kinetic and Thermodynamic Evaluation",
        journal: "Water, Air, & Soil Pollution",
        year: 2024,
        impactFactor: 3.8,
        tier: "Q2",
    },
    {
        authors: (
            <>
                Aayush Raizada, Amresh Shukla, Sanjeev Yadav, <strong>Priyanka Katiyar</strong>, Ranjit Kumar
            </>
        ),
        title: "Enhancement of H₂ production via catalytic steam gasification of food waste as feedstock and its ash as a support and promoter for Ni catalyst",
        journal: "International Journal of Hydrogen Energy",
        year: 2024,
        impactFactor: 8.1,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Karan Gupta, Sanjeev Yadav
            </>
        ),
        title: "Selective Extraction of Anti-Fungal Components from Carrot Seeds: Design of Experiment and Artificial Neural Network Modelling",
        journal: "Journal of Supercritical Fluids",
        year: 2023,
        impactFactor: 3.4,
        tier: "Q2",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav, Annapurna Hans
            </>
        ),
        title: "Valorization of lignocellulosic solid waste obtained from essential oil industry for bio-oil production and dye removal",
        journal: "Water Practice & Technology",
        year: 2023,
        impactFactor: 1.6,
        tier: "Q3",
    },
    {
        authors: (
            <>
                Sourodipto Modak, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav, Siddharth Jain, Bappaditya Gole, Dhrubajyoti Talukdar
            </>
        ),
        title: "Generation and characterization of bio-oil obtained from the slow pyrolysis of cooked food waste at various temperatures",
        journal: "Waste Management",
        year: 2023,
        impactFactor: 7.1,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Karan Gupta, Kavita Khatana, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav
            </>
        ),
        title: "Preparation of novel adsorptive membrane using spent spices waste-derived biochar to treat synthetic wastewater",
        journal: "Materials Today: Proceedings",
        year: 2023,
        impactFactor: "C.S.-4.9",
        tier: "Q2",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Karan Gupta, Sandra Saju, Sourodipto Modak, Sanjeev Yadav
            </>
        ),
        title: "Development and physico-chemical characterization of thermally treated spent turmeric root waste to treat dye containing wastewater",
        journal: "Materials Today: Proceedings",
        year: 2023,
        impactFactor: "C.S.-4.9",
        tier: "Q2",
    },
    {
        authors: (
            <>
                Sanjeev Yadav, <strong>Priyanka Katiyar</strong>, Mohd. K. AL Mesfer, Mohd Danish
            </>
        ),
        title: "Syngas production from thermochemical conversion of mixed food waste: A Review",
        journal: "WIREs Energy and Environment",
        year: 2022,
        impactFactor: 5.4,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Sourodipto Modak, Siddharth Jain, <strong>Priyanka Katiyar</strong>, Sanjeev Yadav
            </>
        ),
        title: "Compositional study of bio-oil obtained from torrefaction of mixed food waste using H-NMR, 13C-NMR, DEPT 90 & 135, and GC-MS",
        journal: "Biofuels",
        year: 2022,
        impactFactor: 2.1,
        tier: "Q3",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Karan Gupta, Pushpraj Katiyar, Shabina Khanam
            </>
        ),
        title: "Supercritical fluid extraction of turmeric root oil using CO₂: Experimental analysis and process modelling",
        journal: "Industrial Crops and Products",
        year: 2022,
        impactFactor: 5.6,
        tier: "Q1",
    },
    {
        authors: (
            <>
                Namrata Chakravarty, <strong>Priyanka Katiyar</strong>, Jyoti Singh, R. P. Singh
            </>
        ),
        title: "A potential type-II L-asparaginase from marine isolate Bacillus australimaris NJB19: Statistical optimization, in silico analysis and structural modeling",
        journal: "International Journal of Biological Macromolecules",
        year: 2021,
        impactFactor: 7.1,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Shabina Khanam
            </>
        ),
        title: "Selection of suitable model for the supercritical fluid extraction of carrot seed oil: A parametric study",
        journal: "LWT - Food Science and Technology",
        year: 2020,
        impactFactor: 6.0,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Shabina Khanam
            </>
        ),
        title: "Supercritical CO₂ extraction of carrot seed oil: screening, optimization, and economic analysis",
        journal: "International Journal of Environmental Science and Technology",
        year: 2019,
        impactFactor: 3.0,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Shabina Khanam
            </>
        ),
        title: "Influence of operating parameters on Supercritical fluid extraction of essential oil from Turmeric root",
        journal: "Journal of Cleaner Production",
        year: 2018,
        impactFactor: 9.8,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, Shabina Khanam
            </>
        ),
        title: "Selection of suitable model for different matrices of raw materials used in supercritical fluid extraction process",
        journal: "Separation Science and Technology",
        year: 2017,
        impactFactor: 2.4,
        tier: "Q2",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, V. Subbaramaiah, V.C. Srivastava, I.D. Mall
            </>
        ),
        title: "Catalytic oxidation of nitrobenzene by copper loaded activated carbon",
        journal: "Separation and Purification Technology",
        year: 2014,
        impactFactor: 8.2,
        tier: "Q1",
    },
    {
        authors: (
            <>
                <strong>Priyanka Katiyar</strong>, V.C. Srivastava
            </>
        ),
        title: "Photocatalytic Oxidation of Dye Bearing Wastewater by Iron Doped Zinc Oxide",
        journal: "Industrial & Engineering Chemistry Research",
        year: 2013,
        impactFactor: 3.8,
        tier: "Q1",
    },
];



function Timeline() {
    const groupedPublications = publications.reduce((acc, pub) => {
        acc[pub.year] = acc[pub.year] || [];
        acc[pub.year].push(pub);
        return acc;
    }, {});

    const yearColors = ['bg-primary', 'bg-secondary', 'bg-teal-500', 'bg-purple-500', 'bg-blue-500', 'bg-orange-500'];

    return (
        <div className="w-full">
            {Object.keys(groupedPublications)
                .sort((a, b) => b - a)
                .map((year, yearIndex) => (
                    <div key={year} className="mb-6">
                        <div className="flex items-center mb-3">
                            <span className={`${yearColors[yearIndex % yearColors.length]} text-white text-sm font-bold px-3 py-1 rounded shadow-sm`}>
                                {year}
                            </span>
                            <div className="h-px bg-gray-200 dark:bg-gray-700 flex-grow ml-4"></div>
                        </div>
                        <div className="space-y-3">
                            {groupedPublications[year].map((pub, index) => (
                                <div
                                    key={index}
                                    className="group bg-background-light dark:bg-background-dark p-5 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary dark:hover:border-blue-500 hover:shadow-md transition-all"
                                >
                                    <h4 className="font-bold text-gray-800 dark:text-gray-100 group-hover:text-primary dark:group-hover:text-blue-400 transition-colors">
                                        {pub.title}
                                    </h4>
                                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                        {pub.authors}
                                    </p>
                                    <div className="flex justify-between items-center mt-3 pt-3 border-t border-gray-100 dark:border-gray-800">
                                        <span className="text-xs italic text-gray-500">
                                            {pub.journal}
                                        </span>
                                        <span className={`text-xs font-semibold px-2 py-1 rounded ${pub.tier === 'Q1' ? 'text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20' :
                                            pub.tier === 'Q2' ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20' :
                                                'text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20'
                                            }`}>
                                            IF: {pub.impactFactor} | {pub.tier}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
        </div>
    );
}

export default Timeline;